import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useNotifications } from "../../context/Notifications";
import SubmitButton from "../submitButton/SubmitButton";
import "react-country-state-city/dist/react-country-state-city.css";
import Datepicker from "tailwind-datepicker-react";
import { useTranslator } from "../../context/translator";
import { getUsersByCompanyService } from "../../services/user/services";
import {
  getContractByIdService,
  createContractService,
  updateContractService,
} from "../../services/contract/services";
import { PERMISSION_CODE } from "../../utils/enum/enums";
import { useGetCompanyQuery, useGetUserByIdQuery } from "store/api/apiSlice";

const ContractEdit = () => {
  const navigate = useNavigate();
  const { addNotification } = useNotifications();
  const { user } = useSelector((state) => state.user);
  const { data: userProfile, isLoading: userLoading } = useGetUserByIdQuery(
    user.id,
    {
      skip: !user?.id,
      pollingInterval: 60000,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    },
  );

  const { data: company, isLoading: companyLoading } = useGetCompanyQuery(
    userProfile?.user?.companyId,
    {
      skip: !userProfile?.user?.companyId,
    },
  );
  const { contractId, clientId } = useParams();
  const [agents, setAgents] = useState(null);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [show4, setShow4] = useState(false);
  const [show5, setShow5] = useState(false);
  const [show6, setShow6] = useState(false);
  const { translate } = useTranslator();
  const [contract, setContract] = useState({
    contractName: "",
    dateRef: null,
    datePublish: null,
    dateRenovation: null,
    dateLastRenovation: null,
    dateExpiration: null,
    dateJoin: null,
    renovationState: true,
    renovationBy: "unknown",
    executive: "unknown",
    temporality: "per",
    contractType: "dg",
    benefits: "",
    planes: false,
    davivienda: false,
    instacredit: false,
    vallePaz: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [contractTypesOptions] = useState([
    {
      key: "dg",
      name: translate("digital"),
    },
    {
      key: "ph",
      name: translate("physical"),
    },
    {
      key: "sc",
      name: translate("scanned"),
    },
    {
      key: "pl",
      name: "Planes",
    },
    {
      key: "nsg",
      name: translate("no-signature"),
    },
  ]);
  const [temOptions] = useState([
    {
      key: "tmp",
      name: translate("temporary"),
    },
    {
      key: "prm",
      name: translate("permanent"),
    },
  ]);

  const [dateOptions] = useState({
    title: translate("logs-date"),
    autoHide: true,
    todayBtn: true,
    clearBtn: false,
    clearBtnText: translate("clear"),
    theme: {
      background: "bg-gray-50 dark:bg-gray-700",
      todayBtn: "",
      clearBtn: "",
      icons: "",
      text: "text-gray-900 dark:text-white",
      disabledText: "text-slate-300",
      input: "h-14",
      inputIcon: "",
      selected: "",
    },
    icons: {
      // () => ReactElement | JSX.Element
      prev: () => <span>{translate("previous")}</span>,
      next: () => <span>{translate("next")}</span>,
    },
    datepickerClassNames: "absolute",
    defaultDate: null,
    language: "en",
    disabledDates: [],
    weekDays: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
    inputNameProp: "date",
    inputIdProp: "date",
    inputPlaceholderProp: "Select Date",
    inputDateFormatProp: {
      day: "numeric",
      month: "long",
      year: "numeric",
    },
  });

  const handleCancel = () => {
    return navigate(-1);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsLoading(true);
    if (contractId !== "new") {
      const response = await updateContractService({
        contractId,
        data: contract,
      });
      if (response?.contract?.contracts?.acknowledged) {
        addNotification({
          id: Date.now(),
          message: translate("contract-updated"),
          kind: "success",
        });
        //return true; // navigate(-1);
      } else {
        addNotification({
          id: Date.now(),
          message: translate("error-updating-contract"),
          kind: "danger",
        });
      }
    } else {
      const response = await createContractService({
        user: user?.companyId,
        data: {
          ...contract,
          companyId: company?._id,
          customerId: clientId,
        },
      });

      if (response?.contract?.acknowledged) {
        addNotification({
          id: Date.now(),
          message: translate("contract-created"),
          kind: "success",
        });
        //return true; // navigate(-1);
      } else {
        addNotification({
          id: Date.now(),
          message: translate("error-creating-contract"),
          kind: "danger",
        });
      }
    }
    setIsLoading(false);
  };

  const handleChangeDate = (selectedDate, name) => {
    setContract((prev) => ({
      ...prev,
      [name]: selectedDate,
    }));
  };

  const handleClose1 = (state) => {
    setShow1(state);
  };
  const handleClose2 = (state) => {
    setShow2(state);
  };
  const handleClose3 = (state) => {
    setShow3(state);
  };
  const handleClose4 = (state) => {
    setShow4(state);
  };
  const handleClose5 = (state) => {
    setShow5(state);
  };
  const handleClose6 = (state) => {
    setShow6(state);
  };

  const getContract = React.useCallback(async () => {
    if (contractId && contractId !== "new") {
      const data = await getContractByIdService({ contractId });
      setContract({
        ...data.contract,
        ...(data?.contract?.dateRef && {
          dateRef: new Date(data.contract.dateRef),
        }),
        ...(data?.contract?.datePublish && {
          datePublish: new Date(data.contract.datePublish),
        }),
        ...(data?.contract?.dateJoin && {
          dateJoin: new Date(data.contract.dateJoin),
        }),
        ...(data?.contract?.dateRenovation && {
          dateRenovation: new Date(data.contract.dateRenovation),
        }),
        ...(data?.contract?.dateLastRenovation && {
          dateLastRenovation: new Date(data.contract.dateLastRenovation),
        }),
        ...(data?.contract?.dateExpiration && {
          dateExpiration: new Date(data.contract.dateExpiration),
        }),
      });
    }
  }, [contractId]);

  const handleOnChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    setContract((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    getContract();
  }, [getContract]);

  const getUsers = React.useCallback(async () => {
    setIsLoading(true);
    const res = await getUsersByCompanyService({ companyId: company?._id });
    const json = await res;

    if (json.code === PERMISSION_CODE.PERMISSION_DENIED) {
      setAgents([]);
      return;
    }

    setAgents(json);
    setIsLoading(false);
  }, [company?._id]);

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  if (userLoading || companyLoading) return null;

  return (
    <form method="POST" onSubmit={handleSubmit}>
      <div className="grid gap-6 mb-6 md:grid-cols-2">
        <div>
          <label
            htmlFor="contractName"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            {translate("contract-name")}
          </label>
          <input
            type="text"
            id="contractName"
            name="contractName"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="Contract Name"
            value={contract?.contractName}
            required
            onChange={handleOnChange}
          />
        </div>
        <div className="relative">
          <label
            htmlFor="dateRef"
            className="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
          >
            {translate("date-ref")}
          </label>
          <Datepicker
            options={dateOptions}
            value={contract.dateRef}
            onChange={(e) => handleChangeDate(e, "dateRef")}
            show={show1}
            setShow={handleClose1}
          />
        </div>
        <div className="relative">
          <label
            htmlFor="dateJoin"
            className="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
          >
            {translate("date-join")}
          </label>
          <Datepicker
            options={dateOptions}
            value={contract.dateJoin}
            onChange={(e) => handleChangeDate(e, "dateJoin")}
            show={show2}
            setShow={handleClose2}
          />
        </div>
        <div className="relative">
          <label
            htmlFor="dateJoin"
            className="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
          >
            {translate("date-publish")}
          </label>
          <Datepicker
            options={dateOptions}
            value={contract.datePublish}
            onChange={(e) => handleChangeDate(e, "datePublish")}
            show={show3}
            setShow={handleClose3}
          />
        </div>

        <div className="relative">
          <label
            htmlFor="dateRenovation"
            className="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
          >
            {translate("date-renovation")}
          </label>
          <Datepicker
            options={dateOptions}
            value={contract.dateRenovation}
            onChange={(e) => handleChangeDate(e, "dateRenovation")}
            show={show4}
            setShow={handleClose4}
          />
        </div>
        <div className="relative">
          <label
            htmlFor="dateLastRenovation"
            className="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
          >
            {translate("date-last-renovation")}
          </label>
          <Datepicker
            options={dateOptions}
            value={contract.dateLastRenovation}
            onChange={(e) => handleChangeDate(e, "dateLastRenovation")}
            show={show6}
            setShow={handleClose6}
          />
        </div>

        <div className="relative">
          <label
            htmlFor="dateExpiration"
            className="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
          >
            {translate("date-expiration")}
          </label>
          <Datepicker
            options={dateOptions}
            value={contract.dateExpiration}
            onChange={(e) => handleChangeDate(e, "dateExpiration")}
            show={show5}
            setShow={handleClose5}
          />
        </div>

        <div>
          <label
            htmlFor="renovationBy"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            {translate("renovation-by")}
          </label>
          <select
            id="renovationBy"
            name="renovationBy"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            defaultChecked={"unknown"}
            value={contract.renovationBy}
            onChange={handleOnChange}
          >
            <option key={"unknown"} value={"unknown"}>
              {translate("unknown")}
            </option>
            {agents &&
              agents?.map((option) => (
                <option key={option._id} value={option.ext}>
                  {option.firstName} {option.lastName}
                </option>
              ))}
          </select>
        </div>

        <div>
          <label
            htmlFor="renovationState"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            {translate("renovation-state")}
          </label>
          <select
            id="renovationState"
            name="renovationState"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            value={contract?.renovationState}
            onChange={handleOnChange}
            defaultValue={true}
          >
            <option value={true}>{translate("active")}</option>
            <option value={false}>{translate("inactive")}</option>
          </select>
        </div>

        <div>
          <label
            htmlFor="temporality"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            {translate("select-temporality")}
          </label>
          <select
            id="temporality"
            name="temporality"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            value={contract?.temporality}
            onChange={handleOnChange}
            defaultValue={"per"}
          >
            {temOptions?.map((option) => (
              <>
                <option key={option.key} value={option.key}>
                  {option.name}
                </option>
              </>
            ))}
          </select>
        </div>

        <div>
          <label
            htmlFor="contractType"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            {translate("select-contract-type")}
          </label>
          <select
            id="contractType"
            name="contractType"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            value={contract?.contractType}
            onChange={handleOnChange}
            defaultValue={"dg"}
          >
            {contractTypesOptions?.map((option) => (
              <>
                <option key={option.key} value={option.key}>
                  {option.name}
                </option>
              </>
            ))}
          </select>
        </div>

        <div>
          <label
            htmlFor="executive"
            className="block text-sm font-medium text-gray-900 dark:text-white mb-2"
          >
            {translate("executive")}
          </label>
          <select
            id="executive"
            name="executive"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            defaultChecked={"unknown"}
            value={contract.executive}
            onChange={handleOnChange}
          >
            <option key={"unknown"} value={"unknown"}>
              {translate("unknown")}
            </option>
            {agents &&
              agents?.map((option) => (
                <option key={option._id} value={option.ext}>
                  {option.firstName} {option.lastName}
                </option>
              ))}
          </select>
        </div>

        <div className="flex justify-between col-span-1">
          <div className="flex items-center gap-2 ">
            <input
              type="checkbox"
              id="planes"
              name="planes"
              checked={contract?.planes}
              onChange={(e) =>
                handleOnChange({
                  target: { name: "planes", value: e.target.checked },
                })
              }
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
            />
            <label
              htmlFor="planes"
              className="text-sm font-medium text-gray-900 dark:text-white"
            >
              Planes
            </label>
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="davivienda"
              name="davivienda"
              checked={contract?.davivienda}
              onChange={(e) =>
                handleOnChange({
                  target: { name: "davivienda", value: e.target.checked },
                })
              }
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
            />
            <label
              htmlFor="davivienda"
              className="text-sm font-medium text-gray-900 dark:text-white"
            >
              Davivienda
            </label>
          </div>

          <div className="flex items-center gap-2 ">
            <input
              type="checkbox"
              id="instacredit"
              name="instacredit"
              checked={contract?.instacredit}
              onChange={(e) =>
                handleOnChange({
                  target: { name: "instacredit", value: e.target.checked },
                })
              }
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
            />
            <label
              htmlFor="instacredit"
              className="text-sm font-medium text-gray-900 dark:text-white"
            >
              Instacredit
            </label>
          </div>

          <div className="flex items-center gap-2 ">
            <input
              type="checkbox"
              id="vallePaz"
              name="vallePaz"
              checked={contract?.vallePaz}
              onChange={(e) =>
                handleOnChange({
                  target: { name: "vallePaz", value: e.target.checked },
                })
              }
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
            />
            <label
              htmlFor="vallePaz"
              className="text-sm font-medium text-gray-900 dark:text-white"
            >
              Valle Paz
            </label>
          </div>
        </div>
        <div className="col-span-2">
          <label
            htmlFor="email"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            {translate("benefits")}
          </label>
          <textarea
            id="benefits"
            name="benefits"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="Benefits"
            value={contract?.benefits}
            onChange={handleOnChange}
          />
        </div>
      </div>

      <div className="flex justify-between">
        <button
          type="button"
          className="py-2.5 px-5 me-2 mb-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
          onClick={handleCancel}
        >
          {translate("cancel")}
        </button>
        <SubmitButton
          isLoading={isLoading}
          text={translate("save")}
          textLoading={translate("saving")}
          key={"saveEmployee"}
        />
      </div>
    </form>
  );
};

export default ContractEdit;
